<template>
  <div>
    <div :class="isOpen ? 'fl employment-relationship-container' : 'fl employment-relationship-container not-open'">
      <div class='mr-4'>
        <p>Personeelsnummer</p>
        <p class='value' style='font-weight: 600; font-size: 1em;'>{{ employmentRelationship.employeeNumber }}</p>
      </div>
      <div class='hf'>
        <p>Arbeidsverhouding</p>
        <p class='value' style='font-weight: 600; font-size: 1em'>
          vanaf {{ formatDate(employmentRelationship.fromDate) }} tot {{ employmentRelationship.untilDate ? formatDate(employmentRelationship.untilDate) : 'onbepaald' }}
        </p>
      </div>

      <div style='float: right; text-align: right; min-width: 200px;' v-if="isOpen && employmentRelationship.employmentRelationshipDetails.length > 0 ">
        <a class='link gray' style='text-align: right; padding-right: 15px;' @click="handleOpenDetailHistory">Historie Bekijken</a>
        <div style='clear: both;' />
      </div>
    </div>
    <div v-if="isOpen && currentDetail != null">
      <employee-employment-relationship-detail :detail="currentDetail" :employee="employee" />
    </div>
  </div>
</template>

<script>
import Helpers from '@/shared/helpers/functions';
import Compositions from '@/views/helpers/compositions';
import Modal from '@/shared/constants/modal';
import EmployeeEmploymentRelationshipDetail from '@/views/components/employee-details/EmployeeEmploymentRelationshipDetail.vue';

export default {
  name: 'EmployeeEmploymentRelationship',
  components: {
    EmployeeEmploymentRelationshipDetail
  },
  data () {
    return {
      openKey: 'employment-relationship-detail-0'
    };
  },
  props: {
    employmentRelationship: Object,
    employee: Object,
    isOpen: Boolean
  },

  methods: {
    formatDate: (date) => Helpers.Dates.formatDate(date),
    handleToggleOpen (i) {
      this.openKey = 'employment-relationship-detail-' + i;
    },
    handleOpenDetailHistory () {
      this.$store.dispatch(Modal.Actions.OPEN, {
        component: 'EmployeeEmploymentRelationshipDetailsHistory',
        employee: this.employee,
        relationship: this.employmentRelationship
      });
    }
  },

  computed: {
    currentDetail () {
      let c = Compositions.getLatestDetailsFromEmploymentRelationship(this.employmentRelationship);
      return c;
    }
  }
};
</script>

<style lang='scss' scoped>
@import '@/assets/stylesheets/variables.scss';

.employment-details-timeline {
  padding-top: 20px;
  padding-left: 25px;
}

.timeline-indicator-line {
  stroke-width: 4;
  stroke: $secondary;
}
.timeline-indicator-circle-primary {
  fill: $secondary;
}
.timeline-indicator-circle-secondary {
  fill: white;
}

.remove-side-borders {
  td {
    border-top: 0;
  }

  tr {
    :first-child {
      border-left: 0;
    }
    :last-child {
      border-right: 0;
    }
  }
}

.confirmation-table {
  table-layout: fixed;

  tr {
    td {
      width: 100%;
    }

    &:first-child {
      td {
        border-top: 0;
        padding-top: 0;
      }
    }
    &:last-child {
      td {
        border-bottom: 0;
        padding-bottom: 0;
      }
    }
  }
}
.confirmation-table-adjust-padding {
  td {
    &:first-child {
      padding-left: 14px;
    }
    &:last-child {
      padding-right: 14px;
    }
  }
}
.employment-relationship-container {
  cursor: pointer;
  border-top: 1px solid $gray-lighten-2;
  padding-left: 17px;
  padding-top: 20px;
  padding-bottom: 20px;

  &.not-open {
    background-color: $gray-lighten-2;
    border-top: 1px solid $gray-lighten-1;
  }
}

</style>
